// SECTOR-AUTOCOMPLETE-01 — sinónimos para el combobox de sector en
// el formulario de publicación. Permiten que el vendedor escriba
// "pelu", "saas", "tasca", "abogados", etc., y encuentre el
// subsector correcto sin recordar la etiqueta oficial.
//
// Las claves son slugs de subsector (o madre, cuando no hay sub),
// los valores son listas de palabras-gatillo en lower-case sin
// tildes que mapean al mismo sector. El matcher añade
// implícitamente las palabras del propio label.

export const SECTOR_SYNONYMS = {
  // Hostelería y restauración
  'bar-y-cafeteria': ['bar', 'cafeteria', 'cafe', 'tasca', 'taberna'],
  'restaurante': ['resto', 'restauracion'],
  'catering-y-eventos-gastronomicos': ['catering', 'eventos', 'banquete', 'bodas'],
  'pasteleria-y-panaderia': ['pasteleria', 'panaderia', 'reposteria', 'horno'],

  // Turismo y alojamiento
  'hotel-y-alojamiento-turistico': ['hotel', 'hostal', 'apartamento turistico', 'airbnb', 'pension'],
  'agencia-de-viajes': ['agencia viajes', 'turismo', 'tour operador'],
  'turismo-activo-y-experiencias': ['turismo activo', 'aventura', 'experiencias', 'rural'],

  // Comercio
  'moda-y-complementos': ['moda', 'ropa', 'complementos', 'boutique', 'tienda ropa'],
  'alimentacion': ['alimentacion', 'supermercado', 'tienda alimentacion', 'colmado', 'ultramarinos'],
  'ferreteria-hogar-y-decoracion': ['ferreteria', 'hogar', 'decoracion', 'menaje', 'bricolaje'],
  'belleza-y-cosmetica': ['cosmetica', 'perfumeria', 'belleza'],
  'mascotas': ['mascotas', 'tienda animales', 'pet shop'],
  'deporte': ['deporte', 'tienda deportes', 'sport'],
  'comercio-especializado': ['tienda especializada', 'nicho'],

  // Servicios profesionales
  'despacho-juridico': ['abogados', 'juridico', 'legal', 'despacho'],
  'asesoria-y-gestoria': ['asesoria', 'gestoria', 'fiscal', 'contable'],
  'consultoria-empresarial': ['consultoria', 'consulting', 'estrategia'],
  'servicios-financieros-y-seguros': ['financieros', 'seguros', 'broker', 'mediador'],
  'recursos-humanos-y-seleccion': ['rrhh', 'recursos humanos', 'seleccion', 'headhunting'],
  'agencia-inmobiliaria': ['inmobiliaria', 'real estate', 'agencia pisos'],
  'agencia-de-marketing-y-comunicacion': ['marketing', 'comunicacion', 'agencia publicidad', 'ads', 'branding'],

  // Salud y bienestar
  'clinica-medica': ['medico', 'clinica', 'consulta'],
  'clinica-dental': ['dental', 'dentista', 'odontologia'],
  'centro-de-estetica': ['estetica', 'spa', 'belleza'],
  'peluqueria-y-barberia': ['pelu', 'peluqueria', 'barberia', 'barber', 'estilismo'],
  'gimnasio-y-centro-deportivo': ['gimnasio', 'gym', 'fitness', 'crossfit', 'pilates', 'yoga'],
  'fisioterapia-y-rehabilitacion': ['fisio', 'fisioterapia', 'rehabilitacion', 'osteopata'],
  'farmacia-y-parafarmacia': ['farmacia', 'parafarmacia', 'botica'],
  'veterinaria': ['veterinario', 'vet', 'clinica animal'],

  // Software y tecnología
  'saas-marketplace-y-producto-digital': ['saas', 'marketplace', 'producto digital', 'app', 'startup'],
  'agencia-de-desarrollo-a-medida': ['agencia desarrollo', 'software a medida', 'devs', 'programadores'],
  'servicios-it': ['it', 'sistemas', 'hosting', 'ciberseguridad', 'infraestructura', 'cloud'],

  // Industria y manufactura
  'taller-mecanico': ['taller', 'mecanico', 'automocion', 'automovil', 'coches', 'reparacion vehiculos'],
  'carpinteria-y-madera': ['carpinteria', 'madera', 'ebanisteria'],
  'metalurgia-y-construcciones-metalicas': ['metalurgia', 'metal', 'cerrajeria industrial'],
  'textil-y-confeccion': ['textil', 'confeccion', 'sastreria industrial'],
  'produccion-alimentaria': ['produccion alimentos', 'fabrica alimentaria', 'manipulado'],
  'produccion-primaria': ['agricola', 'ganaderia', 'pesca', 'primario', 'extraccion'],
  'produccion-industrial-especializada': ['industrial', 'fabrica', 'manufactura especializada'],

  // Construcción y reformas
  'empresa-constructora': ['constructora', 'construccion'],
  'reformas-integrales': ['reformas', 'rehabilitacion', 'obra'],
  'instalaciones': ['fontaneria', 'climatizacion', 'electricidad', 'renovables', 'placas solares', 'aire acondicionado'],
  'pintura-y-acabados': ['pintura', 'pintor', 'acabados'],
  'promotora-inmobiliaria': ['promotora', 'promocion inmobiliaria'],

  // Transporte y logística
  'transporte-de-mercancias': ['transporte mercancias', 'camiones', 'fletes'],
  'mensajeria-y-ultima-milla': ['mensajeria', 'paqueteria', 'ultima milla', 'reparto'],
  'almacenamiento-y-warehousing': ['almacen', 'warehouse', 'logistica almacenaje'],
  'transporte-de-pasajeros': ['taxi', 'vtc', 'pasajeros', 'cabify', 'uber'],

  // Educación y formación (madre sin subsectores)
  'educacion-y-formacion': ['academia', 'formacion', 'educacion', 'cursos', 'escuela', 'autoescuela', 'idiomas', 'oposiciones'],

  // Servicios para empresas y particulares
  'limpieza-y-mantenimiento': ['limpieza', 'mantenimiento', 'conserjeria'],
  'seguridad': ['seguridad', 'vigilancia', 'alarmas'],
  'jardineria-y-paisajismo': ['jardineria', 'paisajismo', 'jardinero'],
  'mudanzas': ['mudanzas', 'mudanza', 'guardamuebles'],
  'lavanderia-y-tintoreria': ['lavanderia', 'tintoreria', 'lavado en seco'],
  'servicios-funerarios': ['funeraria', 'tanatorio', 'servicios funerarios'],
  'gestion-de-residuos-y-reciclaje': ['residuos', 'reciclaje', 'chatarra', 'puntos limpios'],
  // Activities added after reviewing actual marketplace listings.
  'pubs-y-discotecas': ['pub', 'pubs', 'discoteca', 'disco', 'bar de copas', 'ocio nocturno', 'sala de fiestas'],
  'alquiler-de-maquinaria-y-equipos': ['alquiler maquinaria', 'alquiler de maquinaria', 'alquiler equipos', 'renting maquinaria', 'alquiler herramientas'],
  'distribucion-mayorista-y-suministros-profesionales': ['mayorista', 'distribuidor', 'distribucion b2b', 'suministros industriales', 'equipamiento profesional'],
  'estancos': ['estanco', 'tabaco', 'expendeduria'],
  'gasolineras-y-estaciones-de-servicio': ['gasolinera', 'estacion de servicio', 'combustible'],
  'vending-y-venta-automatica': ['vending', 'maquina expendedora', 'maquinas expendedoras', 'venta automatica'],
  'produccion-de-eventos-y-servicios-audiovisuales': ['eventos', 'audiovisual', 'audiovisuales', 'sonido', 'iluminacion', 'montaje de eventos'],
  'laboratorios-dentales-y-protesis': ['laboratorio dental', 'laboratorio ortodoncia', 'protesis dental', 'protesico dental', 'protesis dentales'],
};
